import React from 'react'
import './styles.scss'

import CancelIcon from '../../assets/svgs/Cancel'

interface IPropType {
  user: {
    id: string
    name: string
    email: string
  }
  className?: string
  style?: object
  onClickDelete: (data: object) => void
}

export default function UserCard({ user, style, className = '', onClickDelete }: IPropType) {
  const handleClickDelete = () => {
    onClickDelete(user)
  }

  return (
    <div style={style} className={`user-card-container ${className}`}>
      <div className='close-icon'>
        <CancelIcon onClick={handleClickDelete} />
      </div>
      <span>Nome: {user.name}</span>
      <span>E-mail: {user.email}</span>
    </div>
  )
}
